/**
 * Data for the Step 3 shrinkage chart: one point per visible domain,
 * direct estimate beside the model estimate with its interval,
 * ordered by the direct estimate (the mockup's reading order). Pure
 * data; the component owns the geometry.
 */

import type { DomainResult } from '@sae/engine';

export interface ShrinkagePoint {
  readonly areaId: string;
  readonly direct: number | null;
  readonly model: number | null;
  readonly lower: number | null;
  readonly upper: number | null;
  readonly gamma: number | null;
  /** Model CV, for the chart's CV strip (same source the table reads). */
  readonly cv: number | null;
  readonly status: DomainResult['status'];
}

export function shrinkagePoints(
  domains: readonly DomainResult[],
): ShrinkagePoint[] {
  return domains
    .map((d) => ({
      areaId: d.domain.areaId,
      direct: d.direct?.estimate ?? null,
      model: d.model?.estimate ?? null,
      lower: d.model?.lower ?? null,
      upper: d.model?.upper ?? null,
      gamma: d.reliability.gamma ?? null,
      cv: d.model !== undefined ? (d.reliability.cv ?? d.model.cv) : null,
      status: d.status,
    }))
    .sort((a, b) => (b.direct ?? 0) - (a.direct ?? 0));
}
